import { atom } from 'jotai';

export const upgradeModalAtom = atom(false);
